import { useState } from 'react';
import { FilterType } from '../FilterData';
import {
  Bottom,
  ButtonBox,
  CancleButton,
  ApplyButton,
} from './OptionModal.styles';
import styled from 'styled-components';

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}
function CaseNumberOption({ onClose, filters, setFilters }: Props) {
  const [year, setYear] = useState(filters.year);
  const [caseNumber, setCaseNumber] = useState(filters.caseNumber);

  const handleReset = () => {
    onClose();
  };
  const handleSubmit = () => {
    setFilters({
      ...filters,
      year: year,
      caseNumber: caseNumber,
    });
    onClose();
  };

  return (
    <Wrapper>
      <OptionBox>
        연도/사건번호
        <Box>
          <NumberInput
            type="number"
            pattern="[0-9]*"
            placeholder="연도"
            value={year}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 4) {
                setYear(e.target.value);
              }
            }}
            style={{ width: '100px' }}
          />
          <span>타경</span>
          <NumberInput
            type="number"
            pattern="[0-9]*"
            placeholder="사건번호"
            value={caseNumber}
            onChange={(e) => setCaseNumber(e.target.value)}
          />
        </Box>
      </OptionBox>
      <Bottom>
        <ButtonBox>
          <CancleButton onClick={handleReset}>취소</CancleButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default CaseNumberOption;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const OptionBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 12px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const Box = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
`;

const NumberInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  border: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  &::placeholder {
    color: #616161;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
  }
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;
